import { render, staticRenderFns } from "./CaseViewer.vue?vue&type=template&id=6dc696ed&scoped=true&"
import script from "./CaseViewer.vue?vue&type=script&lang=js&"
export * from "./CaseViewer.vue?vue&type=script&lang=js&"
import style0 from "./CaseViewer.vue?vue&type=style&index=0&id=6dc696ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc696ed",
  null
  
)

export default component.exports